/**
 * Adapters between AnthropometricForm/ParamEditor's Anthropometric v2
 * body shape and the transcript's captured-item payload shape (matches
 * what the Python agent emits and what Go's SaveSection fan-out reads
 * on Save & next).
 *
 *   ParamEditor onSave body      → captured "add" payload
 *   {parameter, numericValue, unit, valueDisplay, testDate}
 *      →
 *   {parameter, numericValue, unit, valueDisplay, testDate}
 *
 * The shapes are near-identical, so this adapter is thin. It exists for
 * symmetry with the other section adapters and to normalise the
 * testDate into a plain ISO string.
 */

const toIso = (v) => {
  if (!v) return "";
  if (v instanceof Date) return v.toISOString();
  if (typeof v === "string") return v;
  return "";
};

/**
 * ParamEditor onSave body → captured "add" payload.
 */
export function bodyToCapturedAdd(body) {
  return {
    parameter:    body.parameter || "",
    numericValue: (typeof body.numericValue === "number" ? body.numericValue : null),
    unit:         body.unit || "",
    valueDisplay: body.valueDisplay || "",
    testDate:     toIso(body.testDate),
    // Convenience for the review table's display column.
    value:        body.valueDisplay || "",
  };
}

/**
 * Stub — Anthropometric v2 has no distinct update endpoint (corrections
 * are just further Saves), so this maps 1:1 to bodyToCapturedAdd.
 */
export function bodyToCapturedUpdate(body /* , context */) {
  return bodyToCapturedAdd(body);
}
